import { ListItemElement } from '@components/std-components/SelectComponent'
import React, { FC } from 'react'

const DropdownItem: FC<ListItemElement> = ({ option, onSelect }) => {
  return (
    <div className='p-10 cursor-pointer' onClick={() => onSelect()}>
      {option}
    </div>
  )
}

export default DropdownItem
